
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { EPermissionActions } from '@/model/EPermissionActions';
import { IAuthUserData } from '@/store/modules/authModule';

const authModule = namespace('authModule');

interface NavTab {
  route: string;
  icon: string;
  labelKey: string;
  label?: string;
  action?: string;
}

@Component({ name: 'BusinessClientNav' })
export default class BusinessClientNav extends Vue {
  @Prop()
  protected clientId!: number;

  @authModule.Getter('userData')
  protected authUser!: IAuthUserData;

  private allTabs: NavTab[] = [
    { route: 'businessClient', icon: 'mdi-account-group', labelKey: 'clients.nav.details' },
    { route: 'businessClientEdit', icon: 'mdi-pencil', labelKey: 'clients.nav.edit', action: EPermissionActions.ACTION_BUSINESS_CLIENTS_UPDATE },
    { route: 'businessClientCommunities', icon: 'mdi-domain', labelKey: 'clients.nav.communities' },
  ];

  get visibleTabs(): NavTab[] {
    return this.allTabs
      .filter(tab => {
        if (tab.action && !this.$canAction(tab.action)) return false;
        return true;
      })
      .map(tab => ({
        ...tab,
        label: this.$t(tab.labelKey) as string,
      }));
  }

  get activeTabIndex(): number {
    const currentRoute = this.$route.name;
    return this.visibleTabs.findIndex(tab => tab.route === currentRoute);
  }

  tabRoute(tab: NavTab): any {
    return { name: tab.route, params: { clientId: String(this.clientId) } };
  }

  isActive(routeName: string): boolean {
    return this.$route.name === routeName;
  }
}
